// Shared world-space chart image. Empty datasets retain axes and units.
export function drawCourseGraph(canvas, points = [], message = '') {
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = '#0b121d'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  for (const [row, kind, maximum, color, label] of [[0, 'Speed', 40000, '#33cccc', 'Speed · RPM'], [1, 'Torque', 10, '#e66699', 'Torque · Nm']]) {
    const top = 35 + row * 210
    ctx.fillStyle = color
    ctx.font = '20px sans-serif'
    ctx.fillText(label, 65, top)
    for (const fraction of [0, 0.5, 1]) {
      const y = top + 160 - fraction * 135
      ctx.strokeStyle = '#526477'
      ctx.beginPath(); ctx.moveTo(65, y); ctx.lineTo(690, y); ctx.stroke()
      ctx.fillStyle = '#ffffff'; ctx.font = '13px sans-serif'; ctx.fillText(String(maximum * fraction), 3, y)
    }
    ctx.strokeStyle = color; ctx.lineWidth = 3; ctx.beginPath()
    points.forEach((point, i) => {
      const x = 65 + 625 * i / Math.max(1, points.length - 1)
      const y = top + 160 - 135 * Math.min(1, point[`max${kind}Value`] / maximum)
      if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y)
    })
    ctx.stroke()
    if (points.length) {
      ctx.fillStyle = '#ffffff'; ctx.font = '13px sans-serif'
      ctx.fillText(new Date(points[0].timestamp).toLocaleTimeString(), 65, top + 182)
      ctx.fillText(new Date(points[points.length - 1].timestamp).toLocaleTimeString(), 595, top + 182)
    }
  }
  ctx.fillStyle = '#ffffff'; ctx.font = '18px sans-serif'; ctx.fillText(message, 65, 460, 625)
}
